import React from 'react';
import { hideModal } from '../../../app/initApp';
import Button from '../misc/Button';

import styles from './OrderStateSavedConfirmation.module.css';

const OrderStateSavedConfirmation = () => {

  return (
    <div className={styles.confirmation}>
      <div className={styles.header + ' partner-color1'}>THANK YOU!</div>
      <div className={styles.secondaryColorText +  ' partner-color2'}>YOUR ORDER HAS BEEN SUCCESSFULLY SAVED</div>
      <div className={styles.primaryColorText +  ' partner-color1'}>YOU CAN RETURN AND FINISH THIS ORDER AT ANOTHER TIME</div>
      <Button
        className={styles.button + ' partner-background-color1 partner-border-color1'}
        label="AWESOME!"
        onClick={() => {
          hideModal();
        }} />
    </div>
  );

}

export default OrderStateSavedConfirmation;
